import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { MAT_DATE_FORMATS, MatDateFormats } from '@angular/material';
import * as moment from 'moment';


export const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateInputComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DateInputComponent),
      multi: true
    }
  ],
})
export class DateInputComponent implements ControlValueAccessor, Validator {
  @Input() placeholder: string = 'dd/mm/yyyy';
  @Input() minDate?: Date;
  @Input() required?: boolean;
  @Input() label: string = 'Date';

  dateControl = new FormControl();

  @Input() control!: FormControl;

  private onChange = (value: any) => { };
  private onTouched = () => { };

  writeValue(value: any): void {
    this.dateControl.setValue(value, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.dateControl.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.dateControl && this.dateControl.errors || null;
  }

  getErrorMessage(): string | null {
    if (this.dateControl.hasError('required')) {
      return 'Date is required';
    }

    if (this.dateControl.hasError('matDatepickerParse')) {
      return 'Invalid date format';
    }

    if (this.control && this.control.errors) {
      const errorMessage = Object.values(this.control.errors)[0] as string;

      if (errorMessage) this.dateControl.setErrors({ errorMessage });

      return errorMessage
    }
    else this.dateControl.setErrors(null);

    return null;
  }

}
